import * as React from 'react';
import { useTranslations } from '../../../common/translation';
import { Button } from '../../../components/button/Button';
import translations from '../translations';
import { TourFeatureBannerProps } from './TourFeatureBanner.props';
import {
  FeatureContainer,
  FeatureContent,
  FeatureContentButtonContainer,
  FeatureContentContainer,
  FeatureContentHeader,
  FeatureContentLink,
  FeatureContentSuperTitle,
  FeatureContentTitle,
  FeatureImage,
  FeatureLogoIconContainer,
  FeatureLogoImage,
} from './TourFeatureBanner.styles';

export const TourFeatureBanner = ({
  imageSrc,
  logo,
  onPreviewClick,
  superTitle,
  ticketsHref,
  title,
  websiteHref,
}: TourFeatureBannerProps) => {
  const { t } = useTranslations(translations);

  let featureLogo;
  if (logo?.hasOwnProperty('src')) {
    featureLogo = <FeatureLogoImage alt={(logo as Image).alt} src={(logo as Image).src} />;
  } else {
    const FeatureLogoIcon = logo as React.FunctionComponent;
    featureLogo = (
      <FeatureLogoIconContainer>
        <FeatureLogoIcon />
      </FeatureLogoIconContainer>
    );
  }

  return (
    <FeatureContainer>
      <FeatureImage src={imageSrc} />
      {featureLogo}
      <FeatureContentContainer>
        <FeatureContent>
          <FeatureContentHeader>
            <FeatureContentLink href={websiteHref} target='_blank'>
              <FeatureContentSuperTitle>{superTitle}</FeatureContentSuperTitle>
              <FeatureContentTitle>{title}</FeatureContentTitle>
            </FeatureContentLink>
          </FeatureContentHeader>
          <FeatureContentButtonContainer>
            {!ticketsHref && !onPreviewClick && (
              <Button disableCaps={true} href={websiteHref} invertColors={true} target='_blank'>
                {t('visitWebsiteText', 'Visit Website')}
              </Button>
            )}
            {ticketsHref && (
              <Button disableCaps={true} href={ticketsHref} invertColors={true} target='_blank'>
                {t('getTicketsText', 'Get Tickets')}
              </Button>
            )}
            {onPreviewClick && (
              <Button disableCaps={true} invertColors={true} onClick={onPreviewClick}>
                {t('previewTourText', 'Preview Tour')}
              </Button>
            )}
          </FeatureContentButtonContainer>
        </FeatureContent>
      </FeatureContentContainer>
    </FeatureContainer>
  );
};
